module.exports = __webpack_public_path__ + "assets/img/teacher (2).228de4bb.png";